import { FC } from 'react';
import CarDetail from './CarDetail';
import UseCarDetail from './UseCarDetail';

const CarDetailContainer: FC = () => {
  return <CarDetail {...UseCarDetail()} />;
};

export default CarDetailContainer;
